import { keyMirror } from 'utils/keyMirror';

export const ActionTypes = keyMirror(
  {
    MOVE_SCREEN: null,
  },
  'ScreensPanel',
);
